<template>
  <div class="button-service-status-container">
    <div v-if="vUpdate" class="flex-align wrapper">
      <div class="select">
        <select class="input-border" v-model="value.status">
          <option v-for="(item,idx) in option" :key="`opt-${idx}`"
            :value="item.value">{{ item.label }}</option>
        </select>
      </div>
      <button class="button" @click="clickUpdate">변경</button>
      <button class="button" @click="vUpdate=false">취소</button>
    </div>
    <button v-else-if="service.status !== 101"
      class="button" @click="clickVUpdate">상태 변경</button>
  </div>
</template>

<script>
import LpAdmDropInput from "../../../../module/common/LpAdmDropInput";
export default {
  name: "ButtonServiceStatus",
  components: {LpAdmDropInput},
  props: {
    service: {
      type: Object
    }
  },
  data() {
    return {
      vUpdate: false,
      value: {status: 0},
      option: [
        {value: 0, label: '이용 예정'},
        {value: 5, label: '개설진행중'},
        {value: 6, label: '디자인 수정 중'},
        {value: 9, label: '서비스 중'},
        {value: 10, label: '관리자 정지'},
        {value: 99, label: '전체정지(EC2 삭제)'},
        {value: 100, label: '이용중단(EC2 삭제)'}
      ]
    }
  },
  methods: {
    clickVUpdate() {
      this.value.status = this.service.status;
      this.vUpdate = true;
    },
    clickUpdate() {
      this.$axios.patch(this.getUrl(`launchpack/service/${this.service.id}`), {status: this.value.status}).then(res => {
        if(res.status === 200) {
          this.service.status = this.value.status;
          this.vUpdate = false;
        }
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
  .button-service-status-container
    margin 12px 0
  .wrapper
    gap 12px
  .button
    width 80px
  .select
    width 150px
</style>
